import { render, staticRenderFns } from "./Func60Communicator.vue?vue&type=template&id=1ac7b0ac&scoped=true"
import script from "./Func60Communicator.vue?vue&type=script&lang=js"
export * from "./Func60Communicator.vue?vue&type=script&lang=js"
import style0 from "./Func60Communicator.vue?vue&type=style&index=0&id=1ac7b0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac7b0ac",
  null
  
)

export default component.exports